import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const handleGetWalletBalance = async () => {
  const walletRes = await AxiosGetMethod(`org/wallet/balance`);
  if (walletRes.status === 200) {
    return walletRes.data.data;
  } else {
    if (walletRes?.status === 401) HandleLogout();
    ErrorToast("Can't find Wallet balance");
    return null;
  }
};

export default handleGetWalletBalance;
